module.exports = __webpack_public_path__ + "static/media/board.080b603e.png";